import { render } from "./PerCircle.vue?vue&type=template&id=652a6c40&scoped=true"
import script from "./PerCircle.vue?vue&type=script&lang=js"
export * from "./PerCircle.vue?vue&type=script&lang=js"

import "./PerCircle.vue?vue&type=style&index=0&id=652a6c40&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652a6c40"]])

export default __exports__